var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"eX39Wed0O1214ufoHcvc5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const ENV = process.ENV || process.env.NEXT_PUBLIC_ENV || 'development';

const routeSamplingRate = {
  '/article': 0.5,
  '/case': 0.5,
  '/help': 0.5,
  '/project': 0.5,
  '/user': 0.5,
  '/cases': 0.5,
  '/projects': 0.5,
};

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    sendDefaultPii: false,
    tracesSampler: ({ name, transactionContext }) => {
      const op = transactionContext?.op;

      if (op !== 'pageload' && op !== 'navigation') {
        return 0;
      }

      const matchedRoute = Object.keys(routeSamplingRate).find(({ route }) =>
        name.startsWith(route)
      );

      const samplingRate = matchedRoute ? routeSamplingRate[matchedRoute] : 0.5;

      return samplingRate;
    },
    integrations: [Sentry.browserTracingIntegration()],
  });
}
